import React from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router";
import { Breadcrumbs, Link, Typography, Box } from "@mui/material";
import { HomeIcon, NavigateNextIcon } from "../../icons";
import { useRootStore } from "../../store/contexts";
import { BreadcrumbCrumb } from "../../router/types";

export const BreadcrumbsBar = observer(() => {
  const navigate = useNavigate();
  const rootStore = useRootStore();
  const { langStore, authStore } = rootStore;

  // No mostrar breadcrumbs si no hay usuario logueado
  if (authStore.status !== "logged") {
    return null;
  }

  // NavigationGuard maneja la verificación de cambios sin guardar automáticamente
  function handleBreadcrumbClick(crumb: BreadcrumbCrumb, index: number) {
    if (index === 0) {
      rootStore.clearBreadcrumbs();
    } else {
      rootStore.popToBreadcrumb(index - 1);
    }
    navigate(crumb.pathname);
  }

  const fullBreadcrumbs: BreadcrumbCrumb[] = [
    { label: langStore.homeLabel || "Inicio", pathname: "/", clickable: true },
    ...rootStore.breadcrumbStack
  ];

  return (
    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', ml: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          color: 'primary.main',
          '& .MuiBreadcrumbs-separator': {
            color: 'primary.light'
          }
        }}
      >
        {fullBreadcrumbs.map((crumb, idx) =>
          crumb.clickable ? (
            <Link
              key={idx}
              underline="hover"
              color="inherit"
              onClick={() => handleBreadcrumbClick(crumb, idx)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                '&:hover': { color: 'primary.dark' }
              }}
            >
              {idx === 0 && <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />}
              {crumb.label}
            </Link>
          ) : (
            <Typography key={idx} color="text.primary" sx={{ fontWeight: 500 }}>
              {crumb.label}
            </Typography>
          )
        )}
      </Breadcrumbs>
    </Box>
  );
});
